import { compose, filter, includes, map, matchesProperty, values } from 'lodash/fp';
import { ThunkMiddleware } from 'redux-thunk';
import { fetchMessages } from '../modules/messages/actions/messages';
import { getCurrentThreadId } from '../modules/messages/selectors/threads';
import { NOTIFICATIONS_FETCHED } from '../modules/notifications/actions/common';

const getThreads = compose(
    map('threadId'),
    filter(matchesProperty('messageEventType', 'MessageAdded')),
    map('event'),
    values
);

export default (): ThunkMiddleware =>
    ({ dispatch, getState }) =>
    (next) =>
    (action) => {
        if (action.type === NOTIFICATIONS_FETCHED) {
            const notifiedThreads = getThreads(action.payload);
            const currentThreadId = getCurrentThreadId(getState());
            if (includes(currentThreadId, notifiedThreads)) {
                dispatch(fetchMessages(currentThreadId));
            }
        }
        return next(action);
    };
